export default __webpack_public_path__ + "static/privacyPolicyCookies-cfcee532429a4ed53946622c2d56dade.pdf";